module.exports = {
	"de": {
		"statistics": {
			"24h_activity": "24h Aktivität",
			"7days_activity": "7 Tage Aktivität",
			"actions": "Aktionen",
			"activity": "Aktivität",
			"average_per_day": "Durchschnitt pro Tag",
			"businesskit_opened": "Eindeutige Businesskit-Öffnungen",
			"total_businesskit_opened": "Geöffnet",
			"businesskit_per_lead": "Businesskits pro Lead",
			"businesskit_sent": "Businesskits verschickt",
			"coupon": "Content card",
			"coupons": "Content cards",
			"coupons_opened": "Content-Cards geöffnet",
			"coupons_sent": "Content-Cards verschickt",
			"coupons_viewed": "Content Card Ansichten",
			"cta_clicked": "CTA geklickt",
			"day": "Tag",
			"days": "Tage",
			"get_back_to_lead": "Zurück zum Lead",
			"get_back_to_statistics": "Zurück zu den Statistiken",
			"hour": "Stunde",
			"hours": "Stunden",
			"kit_and_activity": "Kit & Aktivität",
			"kits": "Kits",
			"latest_trackings": "Letzte Aktivitäten",
			"lead_detectors_overview": "Lead-Hunter Übersicht",
			"lead_kit_and_activity": "Lead, Kit & Aktivität",
			"lead_statistics": "Lead-Trackings",
			"leads": "Leads",
			"leads_cold": "Kalt",
			"leads_hot": "Heiß",
			"leads_per_day": "Leads pro Tag",
			"leads_per_lead_detector": "Leads pro Lead-Hunter",
			"leads_warm": "Warm",
			"no_data": "Es gibt noch keine Daten. Versuche eine andere Zeitspanne.",
			"no_data_24_hours": "Es gibt keine Daten innerhalb der letzten 24h.",
			"no_data_7_days": "Es gibt keine Daten innerhalb der letzten 7 Tage.",
			"per_bk_opened": "pro geöffnetem Businesskit",
			"project_statistics": "Projekt Statistiken",
			"see_full_report": "Vollständiger Report ansehen",
			"see_full_statistics": "Siehe vollständige Statistiken",
			"see_full_tracking_history": "Siehe komplett Tracking Historie",
			"time_range": "Zeitspanne",
			"tracking_activity": "Aktivität",
			"tracking_kit": "Kit",
			"tracking_lead": "Lead",
			"tracking_time": "Zeit"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./hileadzz_i18n/hileadzz/statistics.de.yml
// module id = 2031
// module chunks = 0